// extracted by mini-css-extract-plugin
export default {"OutputWrapper":"OutputWidget_OutputWrapper__bAZSC"};